import * as z from 'zod';

export const CONTACT_PURPOSES = [
  'general',
  'support',
  'partnership',
  'feedback',
  'manage_community',
  'self_profile',
  'business_profile',
  'technical',
  'billing',
  'account_deletion',
] as const;

export const CONTACT_PURPOSE_OPTIONS = [
  { value: 'general', label: 'General Inquiry' },
  { value: 'support', label: 'Support' },
  { value: 'partnership', label: 'Partnership' },
  { value: 'feedback', label: 'Feedback' },
  { value: 'manage_community', label: 'Manage community' },
  { value: 'self_profile', label: 'Self profile' },
  { value: 'business_profile', label: 'Business profile' },
  { value: 'technical', label: 'Technical' },
  { value: 'billing', label: 'Billing' },
  { value: 'account_deletion', label: 'Request Account Deletion' },
] as const;

export const contactFormSchema = z.object({
  name: z.string().min(2, 'Name must be at least 2 characters'),
  email: z.string().email('Please enter a valid email address'),
  phone: z.string().refine((val) => val === '' || val.replace(/\D/g, '').length >= 10, {
    message: 'Phone number must be at least 10 digits',
  }),
  purpose: z.enum(CONTACT_PURPOSES, { message: 'Please select a purpose' }),
  message: z
    .string()
    .min(10, 'Message must be at least 10 characters')
    .max(1000, 'Message limit exceeded'),
});

export type ContactFormValues = z.infer<typeof contactFormSchema>;
